import loginService from "../services/login.service";

const checkToShowAutomaticReviewLabel = (request) => loginService.isInternal() && !!request.enterAutomaticReviewFlowAt;

const exports = {
    checkToShowAutomaticReviewLabel
};

export default exports;